import { Component, OnInit } from '@angular/core';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss']
})
export class FaqSectionComponent implements OnInit {
  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;

  constructor(
    private autenticacaoService: AutenticacaoService
  ) { }

  ngOnInit(): void {
  }

  faqListCB = [
    {
      question: 'O que é possível realizar nesse portal?',
      secondCopyAnswer: 'Você pode visualizar e gerenciar todos os contratos dos seus carnês, emitir a 2ª via para pagamento e negociar eventuais dívidas de forma prática e rápida.',
      creditCardAnswer: 'Se houver um acordo disponível, você pode negociar sua dívida do cartão. Caso tenha realizado uma negociação pelo portal, é possível emitir a 2ª via dessas parcelas.',
      expanded: false,
      id: 1
    },
    {
      question: 'Onde posso realizar o pagamento da renegociação?',
      secondCopyAnswer: 'O boleto pode ser pago via PIX utilizando o QR code no portal, em uma de nossas lojas, lotéricas, redes bancárias, internet banking ou pelo aplicativo do banQi.',
      creditCardAnswer: 'O boleto pode ser pago em uma de nossas lojas, lotéricas, redes bancárias, internet banking ou pelo aplicativo do banQi.',
      expanded: false,
      id: 2
    },
    {
      question: 'Se meu nome estiver negativado, em quanto tempo ficará limpo após o pagamento?',
      secondCopyAnswer: 'Após o pagamento, o prazo para reabilitação no SCPC/Serasa é de até 5 dias úteis.',
      creditCardAnswer: 'Após o pagamento, o prazo para reabilitação no SCPC/Serasa é de até 5 dias úteis.',
      expanded: false,
      id: 3
    },
    {
      question: 'Meu carnê ou cartão está em atraso. Como proceder?',
      secondCopyAnswer: 'Acesse o portal para emitir a 2ª via ou renegociar o contrato.',
      creditCardAnswer: `Se houver um acordo disponível, você pode negociar sua dívida aqui no portal ou entrar em contato com o atendimento do Bradesco 
      <a href="https://banco.bradesco/html/classic/atendimento/fale-conosco/centrais-de-atendimento.shtm#conteudo-ancora" target="_blank">clicando aqui</a>. 
      Caso o atraso seja de um acordo realizado pelo portal, é possível gerar a 2ª via dessas parcelas.`,
      expanded: false,
      id: 4
    },
    {
      question: 'Se houver atraso no pagamento do acordo realizado, meu nome voltará a ser negativado?',
      secondCopyAnswer: 'Sim. Para evitar a negativação, você pode acessar o portal para gerar a 2ª via do boleto ou fazer o pagamento via PIX para regularizar o débito.',
      creditCardAnswer: 'Sim. Para evitar a negativação, você pode acessar o portal para gerar a 2ª via da parcela atrasada, que pode ser paga sem incidência de juros/multa até 15 dias. Caso haja um novo acordo disponível, negocie sua dívida.',
      expanded: false,
      id: 5
    },
    {
      question: 'Consigo gerar a 2ª via sem estar com o pagamento em atraso?',
      secondCopyAnswer: 'Sim. Acesse o portal e gere a 2ª via da parcela desejada.',
      creditCardAnswer: 'Você pode gerar a 2ª via das parcelas da negociação feita neste portal. Se precisar da 2ª via da fatura do cartão, entre em contato com o atendimento do Bradesco <a href="https://banco.bradesco/html/classic/atendimento/fale-conosco/centrais-de-atendimento.shtm#conteudo-ancora" target="_blank">clicando aqui</a>.',
      expanded: false,
      id: 6
    },
    {
      question: 'Fiz um acordo e paguei a entrada. Em quanto tempo esse acordo será efetivado no sistema?',
      secondCopyAnswer: 'O acordo será efetivado em até 2 dias úteis após o pagamento da entrada.',
      creditCardAnswer: 'O acordo será efetivado em até 2 dias úteis após o pagamento da entrada.',
      expanded: false,
      id: 7
    },
    {
      question: 'Consigo acompanhar meus pagamentos nesse portal?',
      secondCopyAnswer: 'Sim, tanto no portal quanto no aplicativo banQi, você terá acesso ao seu carnê 100% digital.',
      creditCardAnswer: 'É possível acompanhar apenas os pagamentos da negociação feita no portal e gerar a 2ª via das parcelas.',
      expanded: false,
      id: 8
    },
  ]

  faqListPF = [
    {
      question: 'O que é possível realizar nesse portal?',
      answer: 'R: É possível visualizar e gerenciar todos os contratos dos seus carnês, possibilitando a emissão de 2a via para pagamento e também a negociação de eventuais dívidas.',
      expanded: false,
      id: 1
    },
    {
      question: 'Onde posso realizar o pagamento do boleto?',
      answer: 'R: O boleto poderá ser pago em uma de nossas lojas, lotéricas, rede bancária, internet banking ou banQi.',
      expanded: false,
      id: 2
    },
    {
      question: 'Se meu nome estiver negativado, em quanto tempo ficará limpo após o pagamento?',
      answer: 'R: O prazo para reabilitação no SCPC/Serasa é de até 5 dias úteis após pagamento/regularização do débito.',
      expanded: false,
      id: 3
    },
    {
      question: 'Meu boleto venceu. Como proceder?',
      answer: 'R: Acessar o portal para emissão de 2ª via',
      expanded: false,
      id: 4
    },
    {
      question: 'Se houver atraso no pagamento do acordo realizado, meu nome voltará a ser negativado?',
      answer: 'R: Sim. Acesse o portal, clique no botão “Gerar 2º Via”, dentro do contrato desejado. Ao visualizar a lista de parcelas, clique no botão “Gerar 2º Via” da parcela desejada..',
      expanded: false,
      id: 5
    },
    {
      question: 'Consigo emitir a segunda via de um carnê em dia nesse portal?',
      answer: 'R: Sim. Acessar o portal e clicar no botão "Gerar 2ª Via". Ao visualizar a lista de parcelas, clicar no botão "Gerar 2ª Via" da parcela desejada.',
      expanded: false,
      id: 6
    },
    {
      question: 'Fiz um acordo e paguei a entrada. Em quanto tempo esse acordo aparecerá efetivado no sistema?',
      answer: 'R: O acordo aparecerá no portal efetivado 2 dias úteis após o pagamento. Caso não esteja atualizado, entrar em contato na Central de Atendimento.',
      expanded: false,
      id: 7
    },
    {
      question: 'Consigo acompanhar meus pagamentos nesse portal?',
      answer: 'R: Sim. No portal e no aplicativo banQi você terá acesso ao seu carnê digital.',
      expanded: false,
      id: 8
    },
  ]

  handleExpandPanel(id: number) {
    if (this.isCasasBahia) {
      this.faqListCB = this.faqListCB.map((i) => ({ ...i, expanded: i.id === id ? !i.expanded : false }))
      return
    }

    this.faqListPF = this.faqListPF.map((i) => ({ ...i, expanded: i.id === id ? !i.expanded : false }))
  }
}
